<template>
  <div class="header">
    <div class="header-body">
      <div class="row align-items-center">
        <div class="col">
          <h1 class="header-title">Keywords</h1>
        </div>
        <div class="col-auto" v-if="canEditKeywords">
          <router-link to="/create-keyword" class="btn btn-primary">Create Keyword</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const CompanyModule = createNamespacedHelpers('company')

// @vuese
// @group Keywords
// This Component is header that shows about the keyword list table
export default {
  name: 'KeywordListHeader',
  computed: {
    ...CompanyModule.mapGetters(['selectIsPermitted']),
    canEditKeywords() {
      return this.selectIsPermitted('keywordsWriteAccess')
    }
  }
}
</script>
